import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-xx",
  "use": "icon-icon-xx-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-xx\">\n  <path fill=\"#fff\" fill-rule=\"evenodd\" stroke=\"#adb5bd\" d=\"M.5.5h511v511H.5z\" />\n  <path fill=\"none\" stroke=\"#adb5bd\" d=\"m.5.5 511 511m0-511-511 511\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol